import { JsonSerializable } from '@/util/object/JsonSerializable'
import { ReferenceLineItemResponse } from '@/cowboy/order_info/object/ReferenceLineItemResponse'
import { SplitInfoResponse } from '@/cowboy/order_info/object/SplitInfoResponse'
import { RewardLinkItemResponse } from '@/cowboy/order_info/object/RewardLinkItemResponse'

export class OrderInfoResponse extends JsonSerializable {
  /** @type {ReferenceLineItemResponse} */
  #referenceLineItem
  /** @type {SplitInfoResponse} */
  #splitInfo
  /** @type {RewardLinkItemResponse} */
  #item

  constructor (jsonObject) {
    super()
    this.#referenceLineItem = ReferenceLineItemResponse.fromJSON(jsonObject.referenceLineItemId)
    this.#splitInfo = SplitInfoResponse.fromJSON(jsonObject.splitInfo)
    this.#item = RewardLinkItemResponse.fromJSON(jsonObject.item)
    Object.freeze(this)
  }

  /**
   * Order reference line item identifiers
   * @return {ReferenceLineItemResponse}
   */
  get referenceLineItem () {
    return this.#referenceLineItem
  }

  /**
   * SplitIO info
   * @return {SplitInfoResponse}
   */
  get splitInfo () {
    return this.#splitInfo
  }

  /**
   * Basic Reward link info
   * @return {RewardLinkItemResponse}
   */
  get item () {
    return this.#item
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      referenceLineItemId: this.#referenceLineItem?.toJSON(),
      splitInfo: this.#splitInfo?.toJSON(),
      item: this.#item?.toJSON()
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {OrderInfoResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new OrderInfoResponse(jsonObject)) || undefined
  }
}
